import { ref } from 'vue';
import { StaticContent, Location } from '@/types';

export const state = ref({
    staticContent: null as null | StaticContent,
    dynamicContent: null as null | Location[],
    activeLanguageCode: 'da',
});
